import React, {useMemo} from 'react';
import imgInvisible from './img_invisible.png';

import './InvisibleProduct.css';
import {Link} from "react-router-dom";
import PropTypes from 'prop-types';
import {VISIBLE_TYPE} from '../../models/product';

/**
 * 숨김 상품 UI
 * @param visibleType
 * @returns {JSX.Element}
 * @constructor
 */
export default function InvisibleProduct({visibleType}) {
    const textByVisibleType = useMemo(() => {
        if (visibleType === VISIBLE_TYPE.BLOCK) {
            return '이 멤버의 상품 정보를 확인할 수 없어요.\n'
        } else {
            return '숨김 처리된 상품입니다.';
        }
    }, [visibleType])

    return (
        <div className='InvisibleProduct-container'>
            <img className='InvisibleProduct-img' src={imgInvisible} alt="숨김 처리된 상품입니다." />
            <div className='InvisibleProduct-title'>{textByVisibleType}</div>
            {visibleType === VISIBLE_TYPE.BLOCK && <span className='InvisibleProduct-desc'>내가 상대를 차단했거나, 상대가 나를 차단했을 수 있어요.</span>}
            <Link to={'/collection/1'} className='InvisibleProduct-link'>
                {'후루츠 인기 매물 구경하기 >'}
            </Link>
        </div>
    );
}

InvisibleProduct.propTypes = {
  visibleType: PropTypes.number
}
